<template lang="pug">
  div
    section.content-header
      h1 ライセンス情報
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active ライセンス情報

    section.content

      mixin btnbar
        .row.bcard-btnbar(class!=attributes.class)
          .col-sm-6
            router-link.btn.btn-default(:to="{name: 'admin'}" title="戻る"): i.fa.fa-reply

      +btnbar
      //- 読み込み中はぐるぐる表示
      .panel.panel-default(v-if="isLoading")
        loading

      //- 読み込み中は表示しない
      .box.box-widget(v-if="!isLoading")
        .box-body

          .form-group
            label.control-label(for="") 会社名
            p.form-control-static {{company_name}}

          .form-group
            label.control-label(for="") 会社名（よみがな）
            p.form-control-static {{company_kana}}

          .form-group
            label.control-label(for="") 企業コード
            p.form-control-static {{company_code}}

          .form-group
            label.control-label(for="") 名刺契約枚数
            p.form-control-static {{formatted_bcard_count}} 枚 / {{formatted_contract_count}} 枚
              |
              |
              span(:class="Number(formatted_bcard_usage) > 100 ? 'text-red text-bold': ''") ({{formatted_bcard_usage}} %)

          .form-group
            label.control-label(for="") 修正サービス契約
            p.form-control-static {{contract_input === app_flag.ON ? '契約あり' : '契約なし'}}

          .form-group
            label.control-label(for="") 同一人物判定バッチ開始日
            p.form-control-static {{formatted_judgement_date || app_lang.NO_SELECT}}

      +btnbar(class="-bottom")

</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import checkboxItem from './_UserSetting_checkbox-item'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const LicenseSettingRepository = RepositoryFactory.get('licenses')

export default {
  name: 'License',
  components: { AppMessages, checkboxItem, Loading },
  data: function () {
    return {
      company_code: '',
      company_name: '',
      company_kana: '',
      contract_input: '',
      formatted_contract_count: '',
      formatted_bcard_count: '',
      formatted_bcard_usage: '',
      formatted_judgement_date: '',
      isLoading: true // 読み込み中かどうか
    }
  },
  created: function () {
    const vm = this

    // API実行
    LicenseSettingRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.company_code = data.company_code
        vm.company_name = data.company_name
        vm.company_kana = data.company_kana
        vm.contract_input = data.contract_input
        vm.formatted_contract_count = data.formatted_contract_count
        vm.formatted_bcard_count = data.formatted_bcard_count
        vm.formatted_bcard_usage = data.formatted_bcard_usage
        vm.formatted_judgement_date = data.formatted_judgement_date
        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/LicenseSetting.vue